import React, { JSX } from 'react';
import { SpaceProps } from 'styled-system';
import {
  StyledDetailsRow,
  StyledLine,
  StyledRowTitle,
  StyledRowValue
} from './style';

type DetailsRowType = SpaceProps & {
  title: JSX.Element | string;
  value: JSX.Element | string;
  lineColor?: string;
};
const DetailsRow: React.FC<DetailsRowType> = ({
  title,
  value,
  lineColor,
  ...rest
}) => {
  return (
    <StyledDetailsRow {...rest}>
      <StyledRowTitle {...rest}>{title}</StyledRowTitle>
      <StyledLine lineColor={lineColor} mx={4}></StyledLine>
      <StyledRowValue>{value}</StyledRowValue>
    </StyledDetailsRow>
  );
};

export default DetailsRow;
